const status = {
  created: 'Manuell angelegt / importiert',
  new: 'Neuer Kontakt',
  followUp: 'Follow-up',
  unreached: 'Aktuell nicht erreicht',
  unreachedAtAll: 'Überhaupt nicht erreicht',
  noFurtherContact: 'Kein weiterer Kontakt erwünscht',
  reached: 'Erfolgreich kontaktiert',
  appointmentOnSite: 'Termin vor Ort vereinbart',
  orderReceived: 'Auftrag erhalten'
}

export const defaultSystemStatuses = [
  'created',
  'new',
  'followUp',
  'unreached',
  'unreachedAtAll',
  'noFurtherContact',
  'reached',
  'appointmentOnSite',
  'orderReceived'
]

export const statusForSelect = Object.entries(status).map(([value, text]) => ({ value, text }))

export default status
